<template>
    <div class="study-requests">
        <v-data-table
            :expand="false"
            :pagination="get_requests_pagination"
            :headers="get_requests_headers"
            item-key="id"
            :items="get_requests"
            :total-items="get_total_requests"
            hide-actions
            @update:pagination="tableSortHandle"
        >
            <template #headerCell="{ header }">
                <v-layout align-center>
                    {{ $t(header.text) }}
                    <img
                        v-if="header.sortable || header.sortable === undefined"
                        width="8px"
                        class="v-icon"
                        :src="get_requests_pagination.sortBy ? '/icons/sort-chevrons-active.svg' : '/icons/sort-chevrons.svg'"
                        alt="sort"
                    >
                </v-layout>
            </template>
            <template #items="props">
                <study-plan-request-row
                    :row="props.item"
                    :expanded="props.expanded"
                    @click="() => props.expanded = !props.expanded"
                />
            </template>
            <template v-slot:expand="{ item }">
                <study-plan-request-row-expand :row="item" />
            </template>
            <template #no-data>
                <v-layout justify-center class="body-2">
                    {{ $t("По запросу ничего не найдено.") }}
                </v-layout>
            </template>
        </v-data-table>
        <v-pagination
            v-if="get_total_requests"
            :value="get_requests_pagination.page"
            total-visible="5"
            :length="Math.ceil(get_total_requests / get_requests_pagination.rowsPerPage)"
            @input="paginationHandle"
        />
    </div>
</template>

<script>
import {mapGetters, mapActions, mapMutations} from 'vuex';
import StudyPlanRequestRow from './Study_plan-request_row.vue';
import StudyPlanRequestRowExpand from './Study_plan_request_row_expand.vue';

export default {
  name      : 'StudyPlanRequests',
  components: {
    StudyPlanRequestRow,
    StudyPlanRequestRowExpand,
  },
  computed: {
    ...mapGetters('study_plan', [
      'get_requests_headers',
      'get_requests_pagination',
      'get_requests',
      'get_total_requests',
    ]),
  },
  methods: {
    ...mapActions('study_plan', ['fetch_requests']),
    ...mapMutations('study_plan', [
      'SET_REQUESTS_PAGINATION',
    ]),
    paginationHandle(pagination) {
      this.SET_REQUESTS_PAGINATION({
        ...this.get_requests_pagination,
        page: pagination,
      });
      this.fetch_requests({
        column: this.get_requests_pagination.sortBy || '',
        sort  : this.get_requests_pagination.descending ? 'desc' : 'asc',
        page  : pagination - 1,
      });
    },
    tableSortHandle(tableSortData) {
      this.SET_REQUESTS_PAGINATION(tableSortData);
      this.fetch_requests({
        column: tableSortData.sortBy || '',
        sort  : tableSortData.descending ? 'desc' : 'asc',
        page  : tableSortData.page - 1,
      });
    },
  },
};
</script>

<style lang="less">
@import url('../../../less/variables');
.study-requests {
    margin-top: 40px;
    margin-bottom: 80px;
    & .v-datatable__expand-content {
        background-color: #F9F9F9;
    }
    & table.v-datatable thead tr th.column.sortable {
        & i.v-icon {
            display: none;
        }
        & .v-icon {
            opacity: 1;
            transition: none;
            margin-left: 8px;
        }
        &.active .v-icon {
            color: @main-color;
        }
    }
    & table tr td, & table tr th {
        font-size: 14px;
        line-height: 21px;
    }
    & &__head-cell {
        padding: 12px 40px !important;
        background-color: #F3F3F3;
    }
    &__cell-number {
        display: flex;
        align-items: center;
    }
    &__expand-btn {
        margin: 0 8px 0 0;
    }
    & &__row td {
        color: #231F20;
        font-size: 14px;
        font-family: @light-font;
        padding: 20px 40px !important;
    }
}
</style>
